<template>
    <svg width="13" height="47" viewBox="0 0 13 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1V34C1 35.858 1 36.787 1.12312 37.5643C1.80083 41.8433 5.15673 45.1992 9.43565 45.8769C10.213 46 11.142 46 13 46V46" stroke="currentColor" stroke-linecap="round"/>
    </svg>
</template>